export const GLOBAL_BASE_URL = process.env.VUE_APP_API_BASE_URL
export const GLOBAL_BASE_URL2 = process.env.VUE_APP_GLOBAL_API_BASE_URL

//===========================================store function api=========================================
export const EP_CONTACT_US = `${GLOBAL_BASE_URL}contact/us`
export const EP_GET_ECONOMIC_CALENDAR = `${GLOBAL_BASE_URL2}get/calendar`
export const EP_EVENT_HISTORY = `${GLOBAL_BASE_URL2}get/ticker/history`
export const EP_COUNTRY_LIST = `${GLOBAL_BASE_URL2}client_country_list.js
`
